// The competency picker for seasons that run their own question set. Instead of
// the global event type -> technical -> answer cascade, the clip form lists the
// report's own sections and competencies, so a clip can only ever be recorded
// against a competency that exists on the report.
//
// The whole tree (sections and competencies per role) travels with the form as a
// data attribute rather than being fetched: it is a few dozen entries, and it
// makes changing Official or section a local operation.
//
// Delegated on document, like the no-video time fields, so the forms the edit
// modal and the post-save re-render inject over AJAX are covered without
// rebinding per form.

const SECTION_SELECT = ".field_observation_competency_section";
const QUESTION_SELECT = ".field_observation_competency_question";

const parseTree = (select) => {
  try {
    return JSON.parse(select.dataset.competencyTree || "{}");
  } catch (error) {
    return {};
  }
};

// Blank first entry so the field starts unanswered rather than silently
// defaulting to whichever competency happens to sort first.
const fill = (select, options) => {
  if (!select) return;

  select.innerHTML = "";
  select.appendChild(new Option("", ""));
  options.forEach((option) => select.appendChild(new Option(option.label, option.value)));
  select.disabled = options.length === 0;
};

const sectionsFor = (sectionSelect) => {
  const userType = sectionSelect.dataset.userType;

  return (userType && parseTree(sectionSelect)[userType]) || [];
};

export function bindCompetencyQuestionFields() {
  $(document)
    .off(".competencyQuestions")
    // The role decides which competencies exist, so changing Official rebuilds the
    // sections and drops whatever competency was picked for the previous one.
    .on("change.competencyQuestions", ".field_observation_user_id", function () {
      const form = this.closest("form");
      const sectionSelect = form && form.querySelector(SECTION_SELECT);
      if (!sectionSelect) return;

      sectionSelect.dataset.userType = $(this).find(":selected").data("user-type") || "";

      fill(
        sectionSelect,
        sectionsFor(sectionSelect).map((section) => ({ label: section.title, value: section.section })),
      );
      fill(form.querySelector(QUESTION_SELECT), []);
    })
    .on("change.competencyQuestions", SECTION_SELECT, function () {
      const form = this.closest("form");
      const questionSelect = form && form.querySelector(QUESTION_SELECT);
      if (!questionSelect) return;

      const section = sectionsFor(this).find((entry) => String(entry.section) === this.value);

      fill(
        questionSelect,
        (section ? section.questions : []).map((question) => ({ label: question.title, value: question.id })),
      );
    });
}
